export const layoutConfig = {
  '1x1': {
    rowVariant: '1x',
    hasMap: false,
    selectableRows: false,
    actionsDirection: 'column',
    actionFontSize: '0.95rem',
    headerFontSize: '0.85rem',
  },
  '1x2': {
    rowVariant: '1x',
    hasMap: true,
    selectableRows: true,
    actionsDirection: 'column',
    actionFontSize: '0.95rem',
    headerFontSize: '0.9rem',
    mapPreviewHeight: 160,
  },
  '2x1': {
    rowVariant: '2x',
    hasMap: false,
    selectableRows: false,
    actionsDirection: 'row',
    actionFontSize: '1rem',
    headerFontSize: '0.9rem',
  },
};
